export default __webpack_public_path__ + "static/media/report_expand.fc64bbeb.svg";